import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { useFeatureTernary } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import {
  DEFAULT_PERFORMER_CAROUSEL_PAGE_SIZE,
  DEFAULT_PERFORMER_IMAGE_SIZE,
} from "src/website-apps/shared/constants/carousel-keys";

interface Carousel {
  key: string;
  count?: number;
  isGridLayout?: boolean;
  imageSize?: { width: number; height: number };
  placeHolderLineCount?: number;
  pageSize?: number;
}

/**
 * Determine which performer carousels are loading and their size
 */
export const usePerformerCarouselLayout = () => {
  const isMobile = !useMediaQuery(Breakpoint.Tablet);

  const execUpdatesForYouExperiment = useFeatureTernary(FeatureSetEnum.TMEventListPickUpWhereYouLeftOffEvents);
  const isUpdatesForYouExperiment = execUpdatesForYouExperiment({
    control: () => false,
    variant: () => true,
    record: false,
  });
  const defaults = {
    imageSize: DEFAULT_PERFORMER_IMAGE_SIZE,
    placeHolderLineCount: 1,
    pageSize: DEFAULT_PERFORMER_CAROUSEL_PAGE_SIZE,
  };
  let signInBannerPosition = 2;
  if (isUpdatesForYouExperiment) {
    signInBannerPosition += 1;
  }

  const carousels: Carousel[] = [
    // Alternative Performers
    { key: "alternative-performers", count: isMobile ? 4 : 6, isGridLayout: true },
    // Events Updates just for you
    ...(isUpdatesForYouExperiment
      ? [
          {
            ...defaults,
            key: "events-updates-for-you",
            placeHolderLineCount: 3,
          },
        ]
      : []),
    // Maybe interested in
    { ...defaults, key: "maybe-interested-in" },
    // Recently Viewed
    { ...defaults, key: "recently-viewed" },
    // Trending Events
    {
      ...defaults,
      key: "trending-events",
      placeHolderLineCount: 3,
    },
  ];

  return {
    ...(!isMobile && { signInBannerPosition }),
    carousels,
  };
};
